<template>
  <div class="login-main">
    <a-form
      class="user-layout-login"
      :form="form"
      @submit="handleSubmit"
    >
      <a-form-item />
      <a-form-item>
        <a-input
          size="large"
          type="text"
          placeholder="账户名或邮箱地址"
          v-decorator="[
            'username',
            {rules: [{ required: true, message: '请输入账户名或邮箱地址' }], validateTrigger: 'change'}
          ]"
        >
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          type="password"
          autocomplete="false"
          placeholder="密码"
          v-decorator="[
            'password',
            {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
          ]"
        >
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item></a-form-item>

      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
        >登录</a-button>
      </a-form-item>

      <div class="user-login-other">
        <router-link class="register" :to="{ name: 'register' }">注册账户</router-link>
      </div>
    </a-form>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import store from '@/store'
import { axios } from '@/utils/request'

export default {
  components: {

  },
  data () {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      }
    }
  },
  created () {

  },
  methods: {
    ...mapActions(['Login']),

    handleSubmit (e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login
      } = this

      state.loginBtn = true

      validateFields((err, values) => {
        if (!err) {
          console.log('login form', values)
          const loginParams = {}
          loginParams.user_name = values.username
          loginParams.user_pwd = values.password

          Login(loginParams).then((permission) => {
            if (typeof permission === 'string') throw permission // 回复是个错误提示
            var x = this.$router.history
            const query = this.$router.history.current.query
            if (query && query.to) {
              const to = query.to
              delete query.to
              this.$router.replace({ path: to, query: query })
            } else this.$store.dispatch('ToHome', { pageName: 'home' })
            setTimeout(() => {

              this.$notification.success({
                message: '欢迎',
                description: `${timeFix()} ：欢迎回来`,
                placement: 'bottomRight'
              })
            }, 2400)
          }).catch(err => {
            setTimeout(() => {
              this.$notification.error({
                message: '登录失败',
                description: err || '请输入正确信息'
              })
            }, 1000)
          }).finally(() => {
            state.loginBtn = false
          })
        } else {
          setTimeout(() => { state.loginBtn = false }, 600)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
